<template>
  <div class="table-container">
    <el-table v-sticky-header stripe fit highlight-current-row height="500" :data="list" header-cell-class-name="table-header-cell" @selection-change="handleSelectionChange">
      <el-table-column v-if="showCheck" type="selection" width="50" align="center" />
      <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell">
        <template slot-scope="scope">
          <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品名称" prop="goodsName" min-width="150" class-name="name-col" />
      <el-table-column label="商品图片" prop="cover" width="100" align="center" class-name="image-col">
        <template slot-scope="{row}">
          <el-image :src="row.cover" :preview-src-list="[row.cover]" lazy />
        </template>
      </el-table-column>
      <el-table-column v-if="showOther" label="用户身份" prop="userGrade" width="80" align="center">
        <template slot-scope="{row}">{{ row.gradeName }}</template>
      </el-table-column>
      <el-table-column label="礼包分类" prop="giftType" width="100" align="center" class-name="status-col">
        <template slot-scope="{row}">
          <div class="flex-tag">
            <el-tag type="success" :effect="row.giftType === 1 ? 'plain' : 'dark'">{{ row.giftType === 1 ? '收益礼包' : '身份礼包' }}</el-tag>
            <el-tag v-if="row.categoryName" type="info" effect="dark">{{ row.categoryName }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="进价和成本" width="120">
        <template slot-scope="{row}">
          <p><span class="bold">供货价：</span>{{ row.stockPrice | filterPrice }}</p>
          <p><span class="bold">成本价：</span>{{ row.costPrice | filterPrice }}</p>
        </template>
      </el-table-column>
      <el-table-column label="零售价" width="100" align="right">
        <template slot-scope="{row}">{{ row.retailPrice | filterPrice }}</template>
      </el-table-column>
      <el-table-column label="售价" width="120">
        <template slot-scope="{row}">
          <p><span class="bold">现金：</span>{{ row.pointPrice | filterPrice }}</p>
          <p><span class="bold">积分：</span>{{ row.point | filterPrice }}</p>
        </template>
      </el-table-column>
      <el-table-column label="供应商" min-width="100" prop="supplierName" />
      <el-table-column v-if="showOther" label="上架状态" width="100" align="center">
        <template slot-scope="{row}">
          <div class="flex align-center just-center">
            <el-switch v-model="row.isOnsale" class="rectangle md" :active-value="1" :inactive-value="0" @change="handleUpdate(row, 'isOnsale')" />
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="showOther" label="操作" align="center" width="100" fixed="right">
        <template slot-scope="{row}">
          <el-button type="text" @click.native="handleEdit(row.id)">编辑</el-button>
          <el-button type="text" @click.native="handleRemove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
  </div>
</template>

<script>
import { getGoodsList, updateGoodsStatus } from '@/api/goods'
import { StickyHeader } from '@cell-x/el-table-sticky'
import Pagination from '@/components/Pagination'

export default {
  name: 'GiftTable',
  components: { Pagination },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  props: {
    params: {
      type: Object,
      default() {
        return {
          referred: 'backend',
          mallType: '4', // 特权礼包
          goodsName: undefined,
          userGrade: undefined,
          giftType: undefined,
          isOnsale: '1',
          page: 1,
          limit: 20
        }
      }
    },
    showCheck: {
      type: Boolean,
      default: false
    },
    showOther: {
      type: Boolean,
      default: true
    },
    idList: {
      type: Array,
      default() {
        return []
      }
    },
    loading: Boolean
  },
  data() {
    return {
      list: [],
      total: 0,
      queryParams: {},
      selectedIds: []
    }
  },
  watch: {
    params: {
      deep: true,
      immediate: true,
      handler(value) {
        if (value) {
          this.queryParams = Object.assign({}, value)
          this.fetchData()
        }
      }
    },
    idList(value) {
      this.selectedIds = value
    }
  },
  methods: {
    fetchData() {
      this.$emit('update:loading', true)
      getGoodsList(this.queryParams).then(response => {
        // console.log(response)
        this.list = response.records
        this.total = response.total
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        setTimeout(() => this.$emit('update:loading', false), 500)
      })
    },
    handleSelectionChange(e) {
      this.selectedIds = e.map(item => {
        return item.id
      })
      this.$emit('update:idList', this.selectedIds)
    },
    handleEdit(goodsId) {
      this.$router.push({ path: `/goods/gift/edit`, query: { from: 'list', id: `${goodsId}` }})
    },
    handleRemove(row) {
      this.$emit('delete', { value: row.id, name: row.goodsName })
    },
    handleUpdate(item, field) {
      updateGoodsStatus(item).then(response => {
        if (!response) item[field] = !item[field]
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
  .table-container {
    display: block;
  }
}
.table-container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  flex: 1;
}
.flex-tag {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .el-tag {
    display: block;
    width: 100%;
    + .el-tag {
      margin-top: 8px;
    }
  }
}
</style>
